module.exports = __webpack_public_path__ + "img/SSIM.dded2bf7.svg";